import Vue from "vue";
import Router from "vue-router";
import auth from "@/auth/authService";
import i18n from "@/i18n/i18n";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "",
            component: () => import("@/layouts/full-page/MainAuth.vue"),
            children: [
                {
                    path: "/",
                    name: "dashboard",
                    component: () => import("@/views/pages/Home.vue"),
                    meta: {
                        hideTitleOnPage: true,
                        rule: "Staff",
                        pageTitle: 'PagesHome'
                    }
                },
                {
                    path: "/auth/transactions",
                    name: "transactions",
                    component: () => import("@/views/Auth/Transactions/Transactions.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "ProductManagement" }
                        ],
                        rule: "Staff",
                        pageTitle: 'PagesTransactions'
                    }
                },
                {
                    path: "/auth/paymentgroups",
                    name: "paymentgroupmanagement",
                    component: () => import("@/views/Auth/PaymentGroup/PaymentGroups.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "ProductManagement" }
                        ],
                        rule: "Staff",
                        pageTitle: 'PagesPaymentGroups'
                    }
                },
                {
                    path: "/auth/accessiblegroups",
                    name: "accessiblegroups",
                    component: () => import("@/views/Auth/User/Roles.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Authorized" }
                        ],
                        rule: "User.",
                        pageTitle: 'PagesAccessibleGroups'
                    },
                },
                {
                    path: "/auth/accessiblegroups/create",
                    name: "newrolegroup",
                    component: () => import("@/views/Auth/User/New.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Authorized" },
                            { title: "PagesAccessibleGroups", url: "/auth/accessiblegroups" },
                        ],
                        rule: "User.",
                        pageTitle: 'PagesAccessibleGroupsNew'
                    }
                },
                {
                    path: "/auth/accessiblegroups/:roleGroupId",
                    name: "rolegroupedit",
                    component: () => import("@/views/Auth/User/Edit.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Authorized" },
                            { title: "PagesAccessibleGroups", url: "/auth/accessiblegroups" },
                        ],
                        rule: "User.",
                        pageTitle: 'PagesAccessibleGroupsEdit'
                    }
                },
            ],
        },
        {
            path: "",
            component: () => import("@/layouts/full-page/Main.vue"),
            children: [
                {
                    path: "/payment/:invoiceId/:transactionId?",
                    name: "payment",
                    component: () => import("@/views/fsm/Payment/Invoice.vue"),
                    meta: {
                        breadcrumb: [],
                        rule: "*",
                        pageTitle: 'PagesInvoice',
                        nonAuth: true,
                    }
                },
                {
                    path: "/paymentgroup/:groupId",
                    name: "paymentgroup",
                    component: () => import("@/views/fsm/Payment/PaymentGroup.vue"),
                    meta: {
                        breadcrumb: [],
                        rule: "*",
                        pageTitle: 'PagesInvoice',
                        nonAuth: true,
                    }
                },

            ]
        }, {
            path: "",
            component: () => import("@/layouts/full-page/FullPage.vue"),
            children: [
                {
                    path: "/login",
                    name: "login",
                    component: () => import("@/views/pages/Login.vue"),
                    meta: {
                        rule: "*",
                        isLoginPage: true
                    }
                },
                {
                    path: "/not-authorized",
                    name: "autherror",
                    component: () => import("@/views/pages/NotAuthorized.vue"),
                    meta: {
                        rule: "*"
                    }
                }, {
                    path: "/not-found",
                    name: "notfound",
                    component: () => import("@/views/pages/Error404.vue"),
                    meta: {
                        rule: "*"
                    }
                }, {
                    path: "/maintenance",
                    name: "maintenance",
                    component: () => import("@/views/pages/Maintenance.vue"),
                    meta: {
                        rule: "*"
                    }
                }
            ]
        }, 
        {
            path: "",
            component: () => import("@/layouts/full-page/Main.vue"),
            children: [
                {
                    path: "/:slug",
                    name: "products",
                    component: () => import("@/views/fsm/Payment/Products.vue"),
                    meta: {
                        breadcrumb: [],
                        rule: "*",
                        pageTitle: 'PagesProducts',
                        nonAuth: true,
                    }
                }
            ]
        },
        {
            path: "*",
            redirect: "/not-found",
            meta: {
                rule: "*"
            }
        }
    ]
});

router.afterEach(() => {

    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.pageTitle);
    if (nearestWithTitle) {
        var title = i18n.messages[i18n.locale][nearestWithTitle.meta.pageTitle];
        document.title = title + ' | ' + i18n.messages[i18n.locale].PageTitle;
    } else {
        document.title = i18n.messages[i18n.locale].PageTitle;
    }

    const pageRule = to.meta.rule;
    const isLoginPage = to.meta.isLoginPage;
    const nonAuth = to.meta.nonAuth;

    if (pageRule && auth.isAuthenticated() && !auth.hasUserRole(pageRule))
        return router.push("/not-authorized");
    else if (pageRule && !auth.isAuthenticated() && !isLoginPage && !nonAuth) {
        window.location.assign("https://portal.fsm.edu.tr/login?ReturnUrl=" + process.env.VUE_APP_BASE_URL);
        return;
    }

    if (auth.isAuthenticated() && isLoginPage)
        return router.push("/");

    return next();
});

export default router;
